import { render, staticRenderFns } from "./form_detail_bonus_component.vue?vue&type=template&id=2eba206e&scoped=true"
import script from "./form_detail_bonus_component.vue?vue&type=script&lang=js"
export * from "./form_detail_bonus_component.vue?vue&type=script&lang=js"
import style0 from "./form_detail_bonus_component.vue?vue&type=style&index=0&id=2eba206e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eba206e",
  null
  
)

export default component.exports